var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgProducts = function SvgProducts(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h22v22H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.594 13.871c.295 0 .54.216.586.498l.007.096v3.96c.001.72.55 1.313 1.253 1.38l.133.007H8.53a.594.594 0 0 1 .097 1.18L8.53 21H4.573a2.577 2.577 0 0 1-2.568-2.412L2 18.426v-3.96c0-.329.266-.595.594-.595zm17.812 0c.295 0 .54.216.586.498l.008.096v3.96a2.577 2.577 0 0 1-2.41 2.57l-.163.005H14.47a.594.594 0 0 1-.097-1.18l.097-.008h3.958c.72 0 1.311-.55 1.379-1.253l.006-.133v-3.96c0-.329.266-.595.594-.595zM6.273 4.937l-.001 5.372h2.557l.001-5.372h1.203v5.372h2.557V4.937h1.204l-.001 5.372h2.557V4.937h1.204v5.372H20.9v1.535h-3.348l.001 5.18H16.35l-.001-5.18h-2.557v5.18H12.59l-.001-5.18h-2.558l.001 5.18H8.83v-5.18H6.271l.001 5.18H5.07l-.001-5.18h-2.97V10.31h2.97V4.937h1.204zM18.427 1a2.577 2.577 0 0 1 2.568 2.412l.005.162v3.96a.594.594 0 0 1-1.18.097l-.008-.096v-3.96c0-.72-.55-1.313-1.252-1.38l-.133-.007H14.47a.594.594 0 0 1-.097-1.18L14.47 1h3.958zM8.531 1a.594.594 0 0 1 .097 1.18l-.097.008H4.573c-.72 0-1.311.55-1.379 1.253l-.006.133v3.96a.594.594 0 0 1-1.18.097L2 7.535v-3.96a2.577 2.577 0 0 1 2.41-2.57L4.573 1H8.53z",
    fill: "#000",
    fillRule: "nonzero"
  }))));
};

export default SvgProducts;